import React from "react";

const CheckIcon = () => (
  <svg width="15" height="11" viewBox="0 0 15 11" xmlns="http://www.w3.org/2000/svg">
    <g id="Symbols" fill="none" fillRule="evenodd">
      <g
        id="Checkbox/Checked"
        transform="translate(-5 -7)"
        fill="#FFF"
        fillRule="nonzero"
      >
        <g id="checkbox">
          <g id="check-icon" transform="rotate(-45 19.157 -.243)">
            <rect
              id="Rectangle"
              width="2"
              height="6"
              vectorEffect="non-scaling-stroke"
            />
            <rect
              id="Rectangle-Copy-6"
              transform="rotate(90 6.5 5)"
              x="5.5"
              y="-1.5"
              width="2"
              height="13"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CheckIcon;
